import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import "../athlete-objectives.css";
import { ButtonMob, instance } from "../../../utils/utils";
import DateInputStart from "../../admin/date-input-start";
import { useEffect, useState } from "react";
import moment from "moment";
import ModalInfo from "../../athlete-info/components/modal-info";
import ConfirmDeletionModal from "../../Mob/components/modal-delete";
import CollapsibleItem from "../../athlete-control/components/CollapsibleItem";
import {
  CardioVascularComponent,
  ChallengesComponent,
  CorporalCompositionComponent,
  HabitComponent,
  PhysicTestComponent,
  PRsComponent,
} from "./resumeConstants";
import { testPhysicalBase } from "../constants";
import { useNavigate } from "react-router-dom";
const Step3Objectives = ({
  userValoration,
  userObjectives,
  setFormData,
  formData,
  control,
}) => {
  console.log(formData);
  const challenges = userObjectives?.challenges || {};
  const pr_goals = userObjectives?.pr_goals || {};
  const physical_tests_goals = userObjectives?.physical_tests_goals || {};
  const log = control
    ? userObjectives?.physical_tests_goals || {}
    : userValoration?.physic_test || {};
  const [modal, setModal] = useState(null);
  const [modalError, setModalError] = useState(null);
  const [loading, setLoading] = useState(false);
  const testPhysical = testPhysicalBase.map((item) => ({
    ...item,
    value: control ? log?.[item.controlKey] : null,
    valorationValue: control ? log?.[item.label_actual] : log?.[item.logKey],
  }));
  const navigate = useNavigate();
  const [selectedTests, setSelectedTests] = useState([]);
  const categories = [
    {
      name: "1. Objetivos de construcción de hábitos",
      value: <HabitComponent formData={formData} />,
    },
    {
      name: "2. Objetivos cardiovasculares",
      value: <CardioVascularComponent formData={formData} />,
    },
    {
      name: "3. Objetivos de construcción de composición corporal",
      value: <CorporalCompositionComponent formData={formData} />,
    },
    {
      name: "4.  Test físico",
      value: <PhysicTestComponent formData={formData} />,
    },
    { name: "5. PR´s del atleta", value: <PRsComponent formData={formData} /> },
    {
      name: "6. Retos del atleta",
      value: <ChallengesComponent formData={formData} />,
    },
  ];

  const [planDate, setPlanDate] = useState(null);
  const today = new Date().toLocaleDateString("en-CA");

  // useEffect(() => {
  //   setPlanDate(today);
  // }, []);

  useEffect(() => {
    if (planDate && planDate !== "Fecha de inicio") {
      console.log(planDate);
      let formattedDate = moment(planDate)?.format("DD-MM-YYYY");
      setFormData((prev) => ({
        ...prev,
        control_date: {
          ...prev.control_date,
          next_control_date: formattedDate,
        },
      }));
    }
  }, [planDate]);

  const checkBoxAction = (item, family) => {
    const familyObj = { ...(formData?.[family] || {}) };

    if (familyObj.hasOwnProperty(item.exercise_id)) {
      delete familyObj[item.exercise_id];
    } else {
      familyObj[item.exercise_id] = item || null;
    }

    const updatedFormData = { ...formData };
    if (Object.keys(familyObj).length === 0) {
      delete updatedFormData[family];
    } else {
      updatedFormData[family] = familyObj;
    }

    setFormData(updatedFormData);
  };
  const checkBoxActionChallenge = (item, family) => {
    const familyObj = { ...(formData?.[family] || {}) };

    if (familyObj.hasOwnProperty(item.challenge_id)) {
      delete familyObj[item.challenge_id];
    } else {
      familyObj[item.challenge_id] = item || null;
    }

    const updatedFormData = { ...formData };
    if (Object.keys(familyObj).length === 0) {
      delete updatedFormData[family];
    } else {
      updatedFormData[family] = familyObj;
    }

    setFormData(updatedFormData);
  };
  // const checkBoxActionTest = (name, family, label_actual, value_actual) => {
  //   const familyObj = { ...(formData?.[family] || {}) };

  //   if (familyObj.hasOwnProperty(name)) {
  //     delete familyObj[name];
  //     delete familyObj[label_actual];
  //   } else {
  //     familyObj[name] = formData?.[family]?.[name] || null;
  //     familyObj[label_actual] = value_actual;
  //   }

  //   const updatedFormData = { ...formData };
  //   if (Object.keys(familyObj).length === 0) {
  //     delete updatedFormData[family];
  //   } else {
  //     updatedFormData[family] = familyObj;
  //   }

  //   setFormData(updatedFormData);
  // };
  const checkBoxActionTest = (selectAll = false) => {
    setFormData((prev) => {
      const newData = { ...prev };
      const currentGoals = { ...newData.physical_tests_goals };
      if (selectAll === false) {
        const { physical_tests_goals, ...rest } = newData;
        return rest;
      }

      if (selectAll) {
        // Si ya están todos seleccionados, los deseleccionamos todos
        if (Object.keys(currentGoals).length === testPhysical.length) {
          return {
            ...newData,
            physical_tests_goals: {},
          };
        }
        // Si no, seleccionamos todos
        else {
          const allGoals = {};
          testPhysical.forEach((item) => {
            allGoals[item.label] = null;
            allGoals[item.label_actual] = item.valorationValue;
          });
          return {
            ...newData,
            physical_tests_goals: allGoals,
          };
        }
      }
      return newData;
    });
  };
  function handleAction() {
    let data = { ...formData };
    instance
      .post(`customers/corp/objectives/`, data)
      .then((res) => res.data)
      .then((data) => {
        setLoading(false);
        if (data) {
          localStorage.setItem(
            "GraphicElevvaUserId",
            userObjectives?.customer_id
          );
          navigate(`/Dashboard`);
        }
      })
      .catch((err) => {
        console.log(err, "--------");
        setModalError(
          <ConfirmDeletionModal
            zIndex={1000}
            onCancel={() => {
              setModalError(null);
              setModal(null);
            }}
            onConfirm={() => {
              setModalError(null);
              setModal(null);
            }}
            loader={false}
          >
            <PerfectScrollbar style={{ maxHeight: "5vh" }}>
              {err.response?.data?.error ||
                err.response?.data ||
                "Error al publicar los objetivos"}
            </PerfectScrollbar>
          </ConfirmDeletionModal>
        );
      });
  }

  function sendObjectives() {
    setModal(
      <ModalInfo
        onCancel={() => setModal(null)}
        buttonConfirmText="Confirmar"
        buttonConfirm={true}
        buttonCancelText="Regresar"
        buttonsWidth="80%"
        maxWidth="90rem"
        onConfirm={handleAction}
        loader={false}
      >
        <div className="mb-2">
          <span>
            <strong>Resumen de Objetivos</strong>
          </span>
        </div>
        <PerfectScrollbar className="px-2 w-100" style={{ maxHeight: "50vh" }}>
          {categories.map((item, idx) => (
            <CollapsibleItem key={idx} item={item} />
          ))}
        </PerfectScrollbar>
      </ModalInfo>
    );
  }
  return (
    <div className="h-100">
      {modal}
      {modalError}
      <div className="d-flex justify-content-between ps-4 pb-2">
        <span className="label-step-objectives">4. Test físico</span>
      </div>
      <div
        className="w-100 h-100 d-flex flex-column gap-2"
        style={{ maxHeight: "94%" }}
      >
        <div className="step2-card p-2 w-100" style={{ height: "25%" }}>
          <div
            className="d-flex align-items-center justify-content-between w-100 px-3"
            style={{ gap: "0.5rem" }}
          >
            {/* Columna 1: Checkbox */}
            <div
              style={{ flex: "0 0 7%" }}
              className="d-flex align-items-center"
            ></div>

            {/* Columna 2: Texto */}
            <div style={{ flex: "0 1 40%", lineHeight: "1" }}></div>

            {/* Columna 3: Input */}
            <div className="label-top" style={{ flex: "0 0 25%" }}>
              Valor actual
            </div>
            {/* Columna 4: Input */}
            <div className="label-top" style={{ flex: "0 0 25%" }}>
              Valor objetivo
            </div>
          </div>
          <PerfectScrollbar
            className="px-3"
            style={{ height: "calc(100% - 1rem)" }}
          >
            {Object.keys(physical_tests_goals).length > 0 ? (
              testPhysical.map((item, idx) => (
                <div
                  key={idx}
                  className="d-flex align-items-center justify-content-between py-2 w-100"
                  style={{ gap: "0.5rem", borderBottom: "1px solid #ccc" }}
                >
                  {/* Columna 1: Checkbox */}
                  <div
                    style={{ flex: "0 0 7%" }}
                    className="d-flex align-items-center"
                  >
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        name="user"
                        checked={formData?.physical_tests_goals?.hasOwnProperty(
                          item.label || false
                        )}
                        onClick={(e) => {
                          checkBoxActionTest(e.target.checked);

                          // checkBoxActionTest(
                          //   itemg.label,
                          //   "physical_tests_goals",
                          //   itemg.label_actual,
                          //   itemg.valorationValue
                          // );
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>

                  {/* Columna 2: Texto */}
                  <div style={{ flex: "0 1 40%", lineHeight: "1" }}>
                    <span className="label-step-objectives">{item.name}</span>
                  </div>

                  {/* Columna 3: Input */}
                  <div style={{ flex: "0 0 25%" }}>
                    <input
                      disabled={true}
                      style={{ width: "100%" }}
                      defaultValue={item.valorationValue}
                      type="text"
                      className="input-corporal"
                    />
                  </div>
                  {/* Columna 4: Input */}
                  <div style={{ flex: "0 0 25%" }}>
                    {control ? (
                      <input
                        style={{ width: "100%" }}
                        disabled={
                          !formData?.["physical_tests_goals"]?.hasOwnProperty(
                            item.controlKey
                          )
                        }
                        value={
                          formData?.["physical_tests_goals"]?.[item.controlKey]
                            ? formData?.["physical_tests_goals"]?.[
                                item.controlKey
                              ]
                            : userObjectives?.["physical_tests_goals"]?.[
                                item.controlKey
                              ] || ""
                        }
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            physical_tests_goals: {
                              ...prev.physical_tests_goals,
                              [item.controlKey]: Number(e.target.value),
                            },
                          }));
                        }}
                        type="number"
                        className="input-corporal"
                      />
                    ) : (
                      <input
                        style={{ width: "100%" }}
                        disabled={
                          !formData?.["physical_tests_goals"]?.hasOwnProperty(
                            item.label
                          )
                        }
                        value={
                          formData?.["physical_tests_goals"]?.[item.label] || ""
                        }
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            physical_tests_goals: {
                              ...prev.physical_tests_goals,
                              [item.label]: Number(e.target.value),
                            },
                          }));
                        }}
                        type="number"
                        className="input-corporal"
                      />
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div>
                <span className="input-tooltip-valoration">No hay test</span>
              </div>
            )}
          </PerfectScrollbar>
        </div>
        <div className="d-flex justify-content-between ps-4 pb-2">
          <span className="label-step-objectives">5. PR del atleta</span>
        </div>
        <div className="step2-card  w-100" style={{ height: "25%" }}>
          <div
            className="d-flex align-items-center justify-content-between py-2 w-100 px-3"
            style={{ gap: "0.5rem" }}
          >
            {/* Columna 1: Checkbox */}
            <div
              style={{ flex: "0 0 7%" }}
              className="d-flex align-items-center"
            ></div>

            {/* Columna 2: Texto */}
            <div style={{ flex: "0 1 40%", lineHeight: "1" }}></div>

            {/* Columna 3: Input */}
            <div className="label-top" style={{ flex: "0 0 25%" }}>
              Ultimo record
            </div>
            {/* Columna 4: Input */}
            <div className="label-top" style={{ flex: "0 0 25%" }}>
              Record objetivo
            </div>
          </div>
          <PerfectScrollbar
            className="px-3"
            style={{ height: "calc(100% - 2rem)" }}
          >
            {Object.keys(pr_goals).length > 0 ? (
              Object.values(pr_goals).map((item, idx) => (
                <div
                  key={idx}
                  className="d-flex align-items-center justify-content-between py-2 w-100"
                  style={{ gap: "0.5rem", borderBottom: "1px solid #ccc" }}
                >
                  {/* Columna 1: Checkbox */}
                  <div
                    style={{ flex: "0 0 7%" }}
                    className="d-flex align-items-center"
                  >
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        name="user"
                        onClick={() => checkBoxAction(item, "pr_goals")}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>

                  {/* Columna 2: Texto */}
                  <div style={{ flex: "0 1 40%", lineHeight: "1" }}>
                    <span className="label-step-objectives">
                      {item.exercise_name}
                    </span>
                  </div>

                  {/* Columna 3: Input */}
                  <div style={{ flex: "0 0 25%" }}>
                    <input
                      style={{ width: "100%" }}
                      defaultValue={item?.metric || "---"}
                      type="text"
                      readOnly={true}
                      className="input-corporal"
                    />
                  </div>
                  {/* Columna 4: Input */}
                  <div style={{ flex: "0 0 25%" }}>
                    {control ? (
                      <input
                        disabled={
                          !formData?.["pr_goals"]?.hasOwnProperty(
                            item.exercise_id
                          )
                        }
                        style={{ width: "100%" }}
                        value={
                          formData?.["pr_goals"]?.[item.exercise_id]?.goal
                            ? formData?.["pr_goals"]?.[item.exercise_id]
                                ?.goal || ""
                            : userObjectives?.["pr_goals"]?.[item.exercise_id]
                                ?.goal || ""
                        }
                        type="number"
                        className="input-corporal"
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            pr_goals: {
                              ...prev.pr_goals,
                              [item.exercise_id]: {
                                ...item,
                                goal: Number(e.target.value),
                              },
                            },
                          }));
                        }}
                      />
                    ) : (
                      <input
                        disabled={
                          !formData?.["pr_goals"]?.hasOwnProperty(
                            item.exercise_id
                          )
                        }
                        style={{ width: "100%" }}
                        value={
                          formData?.["pr_goals"]?.[item.exercise_id]?.goal || ""
                        }
                        type="number"
                        className="input-corporal"
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            pr_goals: {
                              ...prev.pr_goals,
                              [item.exercise_id]: {
                                ...item,
                                goal: Number(e.target.value),
                              },
                            },
                          }));
                        }}
                      />
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div>
                <span className="input-tooltip-valoration">No hay retos</span>
              </div>
            )}
          </PerfectScrollbar>
        </div>

        <div className="d-flex justify-content-between ps-4 pb-2">
          <span className="label-step-objectives">6. Retos</span>
        </div>
        <div className="step2-card w-100" style={{ height: "25%" }}>
          <PerfectScrollbar className=" p-3">
            {Object.keys(challenges).length > 0 ? (
              Object.values(challenges).map((item, idx) => (
                <div
                  key={idx}
                  className="d-flex align-items-center justify-content-between py-2 w-100"
                  style={{ gap: "0.5rem" }}
                >
                  {/* Columna 1: Checkbox */}
                  <div
                    style={{ flex: "0 0 7%" }}
                    className="d-flex align-items-center"
                  >
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        name={"challenge_" + idx}
                        onClick={() =>
                          checkBoxActionChallenge(item, "challenges")
                        }
                      />
                      <span className="checkmark"></span>
                    </label>
                  </div>

                  {/* Columna 2: Texto */}
                  <div style={{ flex: "1 1 73%", lineHeight: "1" }}>
                    <span className="label-step-objectives">
                      {item.ch_name}
                    </span>
                  </div>
                </div>
              ))
            ) : (
              <div>
                <span className="input-tooltip-valoration">No hay retos</span>
              </div>
            )}
          </PerfectScrollbar>
        </div>
        <div className="d-flex justify-content-center gap-2 align-items-center">
          <div>
            <span className="label-step-objectives">Fecha próximo control</span>
          </div>
          <div>
            <DateInputStart
              minDate={today}
              setPlanDate={setPlanDate}
              placeholderInput="Fecha"
              // defaultDate={planDate}
            />
          </div>
        </div>
        <div
          className="d-flex justify-content-center gap-2 w-70 mx-auto mb-3"
          style={{ height: "5%" }}
        >
          <ButtonMob
            handleClick={sendObjectives}
            colorButton={"var(--elevvabutonLogin_User)"}
            text={"Publicar objetivos "}
            className={"px-3 h-100"}
            sizeFont=" calc(0.3rem + 0.3vw)"
          />
        </div>
      </div>
    </div>
  );
};

export default Step3Objectives;
